// NOTE: van 生产环境为 prod
export const env = document.documentElement.dataset.vanEnv || 'prod';

export const isProd = env === 'prod';

const API_HOST = {
  stg: 'https://dappweb-stg.xiaolachuxing.com',
  pre: 'https://dappweb-pre.xiaolachuxing.com',
  prod: 'https://dappweb.xiaolachuxing.com',
}[env];

const DCS_API_HOST = {
  stg: 'https://dcs-driver-stg.xiaolachuxing.com/api',
  pre: 'https://dcs-driver-pre.xiaolachuxing.com/api',
  prod: 'https://dcs-driver.xiaolachuxing.com/api',
}[env];

const DIC_API_HOST = {
  stg: 'https://dic-driver-stg.xiaolachuxing.com/api',
  pre: 'https://dic-driver-pre.xiaolachuxing.com/api',
  prod: 'https://dic-driver.xiaolachuxing.com/api',
}[env];

const DPC_API_HOST = {
  stg: 'https://dpc-driver-stg.xiaolachuxing.com/api',
  pre: 'https://dpc-driver-pre.xiaolachuxing.com/api',
  prod: 'https://dpc-driver.xiaolachuxing.com/api',
}[env];

const DRISK_API_HOST = {
  stg: 'https://drisk-stg.xiaolachuxing.com/api',
  pre: 'https://drisk-pre.xiaolachuxing.com/api',
  prod: 'https://drisk.xiaolachuxing.com/api',
}[env];

const SA_HOST = {
  stg: 'https://uba-stg.xiaolachuxing.com/sa?project=xldriver',
  pre: 'https://uba-stg.xiaolachuxing.com/sa?project=xldriver',
  prod: 'https://uba.xiaolachuxing.com/sa?project=xldriver',
}[env];

// 协议条款
const DRIVER_HOST = {
  stg: 'https://xl-driver-index-v-stg.xiaolachuxing.com',
  pre: 'https://xl-driver-index-v-pre.xiaolachuxing.com',
  prod: 'https://driver-h5.xiaolachuxing.com/index',
}[env];

const JOIN_HOST = {
  stg: 'https://xl-driver-join-v-stg.xiaolachuxing.com',
  pre: 'https://xl-driver-join-v-pre.xiaolachuxing.com',
  prod: 'https://driver-h5.xiaolachuxing.com/join',
}[env];

const USER_INDEX_HOST = {
  stg: 'https://xl-user-index-v-stg.xiaolachuxing.com',
  pre: 'https://xl-user-index-v-pre.xiaolachuxing.com',
  prod: 'https://user-h5.xiaolachuxing.com/index',
}[env];

const LUNA_HOST = {
  local: '//luna-upload-stg.xiaolachuxing.com/luna/api',
  dev: '//luna-upload-stg.xiaolachuxing.com/luna/api',
  stg: '//luna-upload-stg.xiaolachuxing.com/luna/api',
  pre: '//luna-upload-pre.xiaolachuxing.com/luna/api',
  gra: '//luna-upload-gra.xiaolachuxing.com/luna/api',
  prod: '//luna-upload.xiaolachuxing.com/luna/api',
  prd: '//luna-upload.xiaolachuxing.com/luna/api',
}[env];

export default {
  DCS_API_HOST,
  DIC_API_HOST,
  DPC_API_HOST,
  DRISK_API_HOST,
  API_HOST,
  SA_HOST,
  DRIVER_HOST,
  USER_INDEX_HOST,
  JOIN_HOST,
  LUNA_HOST,
};
